import { useState } from "react";
import stl from "../../Layout.module.css";
import { CDN_LINK } from "@globalConfig";
import { trackEvents } from "@/common/events/events";
import { useTranslation } from "@i18n";
import chatStl from "./ContactUsPopUp.module.css";
import { useChatBot } from "@hooks/useChatBot";
import useIsWorkingTime from "@hooks/useIsWorkingTime";
import useContactNumbers from "@hooks/useContactNumbers";

export default function ContactUsPopUp() {
    useChatBot();
    const { t } = useTranslation();
    const contactNumbers = useContactNumbers();

    const duringWorkingHours = useIsWorkingTime();
    const [showContactUs, setShowContactUs] = useState(false);

    const toggleContactUs = () => {
        setShowContactUs(!showContactUs);
    };

    return (
        <>
            <div
                className={[
                    "m-show",
                    chatStl.contactUsPopupContainer,
                    duringWorkingHours > 0 ? "onlineP" : "offlineP",
                ].join(" ")}
                onClick={toggleContactUs}
            >
                {duringWorkingHours > 0 && (
                    <div className={stl.imageBlueBg}>
                        <img
                            className={stl.bg}
                            src={CDN_LINK + "/assets/images/greenBG.svg"}
                            alt="blue"
                        />
                        <img
                            src={CDN_LINK + "/assets/images/headsetW.svg"}
                            alt="head set"
                            width={"40px"}
                            height={"40px"}
                        />
                    </div>
                )}
                {!duringWorkingHours > 0 && (
                    <div className={stl.imageBlueBg}>
                        <img
                            className={stl.bg}
                            src={CDN_LINK + "/assets/images/blueBG.svg"}
                            alt="blue"
                            width={"80px"}
                            height={"80px"}
                        />
                        <img
                            src={CDN_LINK + "/assets/images/headsetW.svg"}
                            alt="head set"
                            width={"40px"}
                            height={"40px"}
                        />
                    </div>
                )}
            </div>
            <div
                className={[
                    "m-show",
                    chatStl.ourServiceP,
                    showContactUs ? chatStl.openOurServiceP : undefined,
                ].join(" ")}
                onClick={(e) => e.target === e.currentTarget && toggleContactUs()}
            >
                <div className={stl.contUs}>
                    <img
                        width={15}
                        height={15}
                        className={[chatStl.clsContactUsPopupContainer, "hasEvents"].join(" ")}
                        src={`${CDN_LINK}/assets/bundles/close.svg`}
                        alt=""
                        onClick={toggleContactUs}
                    />
                    {duringWorkingHours > 0 && (
                        <>
                            <img
                                className={stl.imageinBox}
                                width={72}
                                src={CDN_LINK + "/assets/images/HEADs2.svg"}
                                alt="offline"
                            />
                            <strong className="onlineContent">موجودين لخدمتك</strong>
                            <p className="onlineContent">
                                اتصل بنا لطلب مساعدة من خبير السيارات.
                            </p>
                        </>
                    )}

                    {!duringWorkingHours > 0 && (
                        <>
                            <img
                                className={stl.imageinBox}
                                width={72}
                                height={72}
                                src={CDN_LINK + "/assets/images/HEADs1.svg"}
                                alt="offline"
                            />
                            <strong className="offlineContent">
                                {t("نحن الان خارج أوقات العمل الرسمية", {
                                    ns: "web_common",
                                })}
                            </strong>
                            <p className="offlineContent">
                                {t("أرسل لنا استفسارك وسيتم التواصل معك في أقرب وقت.", {
                                    ns: "web_common",
                                })}
                            </p>
                        </>
                    )}

                    {duringWorkingHours > 0 && (
                        <a
                            href={`tel:${contactNumbers.callCenterCallNumber}`}
                            className={["blueBtn", chatStl.CCC].join(" ")}
                        >
                            <div>
                                <img src={CDN_LINK + "/assets/bundles/Call.svg"} alt="" />
                                <span>اتصال</span>
                            </div>
                            <div style={{ direction: "ltr" }}>
                                {contactNumbers.callCenterDisplayNumber}
                            </div>
                        </a>
                    )}

                    <a
                        href={`https://wa.me/${contactNumbers.whatsappCallNumber}`}
                        rel="noopener noreferrer" target="_blank"
                        className={chatStl.CCW}
                        onClick={() => {
                            //onlineContactEvent("whatsapp", "Homepage", null);
                            trackEvents("online_contact", {
                                post_id: null,
                                contact_type: "whatsapp",
                                contact_location: "Homepage",
                            });
                        }}
                    >
                        <div>
                            <img
                                src={`${CDN_LINK}/assets/bundles/wpImg.svg`}
                                alt=""
                                width={24}
                                height={24}
                            />
                            <span> {t("واتساب", { ns: "web_common" })}</span>
                        </div>
                        <div style={{ direction: "ltr" }}>

                            {contactNumbers.whatsappDisplayNumber}
                        </div>
                    </a>

                    <button
                        style={{ display: "none" }}
                        id="pingpongchat"
                        className={[chatStl.chatBtn].join(" ")}
                        onClick={() => {
                            setShowContactUs(false);
                            window.fcWidget.open();
                        }}
                    >
                        <i></i>
                        {t("الدردشة الفورية", { ns: "web_post_view" })}
                    </button>
                </div>
            </div>
        </>
    );
}
